import { styled, Theme } from '@mui/material';
import { CoreDialogTitle, CoreDialogContent, CoreRadioGroup, CoreRadio } from '@youscience/core';

import ActionButton from '@components/ActionButton';

// TODO add colors to library
const linkHoverBg = '#EBF6F7';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      borderRadius: '12px',
    },
  },
  subtitle: {
    marginTop: '2rem',
  },
  questionWrap: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  question: {
    marginTop: '2.5rem',
    marginBottom: '0.75rem',
  },
  scoreLabel: {
    marginTop: '0.375rem',
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    textAlign: 'center',
  },
  notSureMessage: (theme: Theme) => ({
    '& > a:first-of-type': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  }),
  notesTitle: {
    marginTop: '2.5rem',
    marginBottom: '2rem',
  },
  notesField: {
    marginBottom: '2.5rem',
  },
};

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  padding: '1.5rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.up('sm')]: {
    padding: '3.125rem 3.5rem 1.75rem 3.5rem',
  },
}));

export const StyledDialogContent = styled(CoreDialogContent)(({ theme }) => ({
  maxHeight: '500px',
  padding: '0 1.5rem',

  [theme.breakpoints.up('sm')]: {
    padding: '0 2rem 0 3.5rem',
  },
}));

export const StyledRadioGroup = styled(CoreRadioGroup)(() => ({
  marginTop: '2rem',
  marginBottom: '2rem',
}));

export const StyledScoreButtonsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: '1.25rem',
  maxWidth: '44px',

  '> :not(:first-of-type)': {
    marginLeft: '0.5rem',
  },

  [theme.breakpoints.up('sm')]: {
    '> :not(:first-of-type)': {
      marginLeft: '2rem',
    },
  },
}));

export const StyledScoreRadioButton = styled(ActionButton, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ isSelected, theme }) => ({
  backgroundColor: isSelected ? theme.palette.primary.main : theme.palette.common.white,
  border: `1px solid ${theme.palette.grey['300']}`,
  borderRadius: '4px',
  color: isSelected ? theme.palette.common.white : theme.palette.common.black,
  position: 'relative',
  minWidth: '44px',
  height: '44px',
  padding: 0,

  '&:hover': {
    backgroundColor: isSelected ? theme.palette.primary.main : linkHoverBg,
  },
}));

export const StyledRadio = styled(CoreRadio)(() => ({
  position: 'absolute',
  opacity: 0,
  zIndex: 100,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}));
